import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { languagesHelper as language } from '../../util/languages';

import { Heading } from '../../components';

import css from './ListingPage.module.css';

const { Money } = sdkTypes;

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl, marketplaceCurrency } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, valueKey: optionConfig?.option, label })
        : schemaType === 'boolean'
          ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
          : schemaType === 'long'
            ? filteredConfigs.concat({ key, value, label })
            : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  const securityDeposit = publicData?.securityDeposit;
  const insuranceDeductible = publicData?.insuranceDeductible;
  const makeOtherDescription_s1 = publicData?.makeOtherDescription_s1;

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {existingListingFields.map(detail => {
          if (detail.value === "Other") {
            return (
              <li key={detail.key} className={css.detailsRow}>
                <span className={css.detailLabel}>{language.labelsTranslator(`pub_${detail.key}`, intl)}</span>
                <span>{makeOtherDescription_s1}</span>
              </li>
            )
          }
          return (
            <li key={detail.key} className={css.detailsRow}>
              <span className={css.detailLabel}>
                {language.labelsTranslator(`pub_${detail.key}`, intl)}
              </span>
              <span>{detail.valueKey ? language.labelsTranslator(detail.valueKey, intl) : detail.value}</span>
            </li>
          )
        })}

        {!!securityDeposit && (
          <li key="securityDeposit" className={css.detailsRow}>
            <span className={css.detailLabel}><FormattedMessage id="ListingPage.securityDeposit" /></span>
            <span>{formatMoney(intl, new Money(securityDeposit, marketplaceCurrency))}</span>
          </li>
        )}

        {!!insuranceDeductible && (
          <li key="insuranceDeductible" className={css.detailsRow}>
            <span className={css.detailLabel}><FormattedMessage id="ListingPage.insuranceDeductible" /></span>
            <span>{formatMoney(intl, new Money(insuranceDeductible, marketplaceCurrency))}</span>
          </li>
        )}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
